import { render, staticRenderFns } from "./crm-workflows-tab.vue?vue&type=template&id=77aaad72&scoped=true&"
import script from "./crm-workflows-tab.vue?vue&type=script&lang=js&"
export * from "./crm-workflows-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aaad72",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77aaad72')) {
      api.createRecord('77aaad72', component.options)
    } else {
      api.reload('77aaad72', component.options)
    }
    module.hot.accept("./crm-workflows-tab.vue?vue&type=template&id=77aaad72&scoped=true&", function () {
      api.rerender('77aaad72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-crm-app/rfi_process/tabs/crm-workflows/crm-workflows-tab.vue"
export default component.exports